export const SOURCE_LOCATION = 'universal-create';
